<template>
    <App title="Users">
        <div class="row">
            <div class="col">
                <Block>
                    <template #header>
                        <h3 class="block-title">Users</h3>
                    </template>
                    <Datatable :options="options" />
                </Block>
            </div>
        </div>
    </App>
</template>

<script lang="ts">
import Block from '@/vue/components/Block.vue'
import { CellRender } from '@/vue/components/Datatable'
import Datatable from '@/vue/components/Datatable.vue'
import App from '@/vue/templates/App.vue'
import { Config } from 'datatables.net-bs5'
import { Component, toNative, Vue } from 'vue-facing-decorator'

@Component({
    components: {
        App,
        Block,
        Datatable,
    },
})
class Group extends Vue {
    get buttons() {
        let buttons: any[] = []
        buttons.push('refresh')
        buttons.push('trashed')

        return buttons
    }

    get columns() {
        let columns: any[] = []
        columns.push({
            data: 'id',
            orderable: true,
            name: 'id',
            title: 'Id',
        })

        columns.push({
            data: 'tag',
            title: 'Tag',
        })

        columns.push({
            data: 'fullname',
            title: 'Name',
            orderable: true
        })
        columns.push({
            data: 'email',
            title: 'email',
            orderable: true
        })

        columns.push({
            data: 'phone',
            title: 'Phone',
            render: CellRender.phone(),
            name: 'phone',
            orderable: true
        })

        columns.push({
            data: 'created_at',
            title: 'Registered',
            render: CellRender.date(),
            orderable: true
        })

        columns.push({
            data: 'url',
            render: CellRender.actions(null, { update: false }),
        })

        return columns
    }

    get options(): Config {
        return {
            ajax: {
                url: this.route('user.ajax.table'),
                method: 'POST',
            },
            buttons: this.buttons,
            columns: this.columns,
        }
    }
}

export default toNative(Group)
</script>
